import { createImportCallback, LazyComponent } from '@dui/LazyComponent';
import { QrCodeBaseProps, QrCodeFallbackErrorProps } from './types';
import { QrCodeFallbackLoading } from './QrCodeBaseLoading';
import { QrCodeFallbackError } from './QrCodeFallbackError';

const importCallback = createImportCallback(() => import('./QrCodeBase'));

export function QrCode(props: QrCodeBaseProps & Pick<QrCodeFallbackErrorProps, 'errorText'>) {
  return (
    <LazyComponent
      importCallback={importCallback}
      importCallbackSelector={(resp) => resp.QrCodeBase}
      ErrorFallback={({ retry }) => <QrCodeFallbackError retry={retry} {...props} />}
      LoadingFallback={() => <QrCodeFallbackLoading {...props} />}
      {...props}
    />
  );
}
